import React from "react";
import _ from "lodash";
import { Routes, Route } from "react-router-dom";

import { lazyRetry } from "src/utils/lazyRetry";

/* ── СТАТИК: ажилтны ӨДӨР ТУТМЫН зам ───────────────────────────────────
   15А/5А урьдчилсан шалгалт, ажилд гаргах зөвшөөрөл, АШУА-ийн өдөр
   тутмын тайлан — ээлж бүр ашиглагддаг тул chunk татахгүй байх ёстой
   (router.js-ийн архитектурын зарчим).                                */
import HighRiskContext from "src/contexts/high_risk/highriskContext";
import Register from "src/pages/high_risk/register/index";
import List from "src/pages/high_risk/list/index";
import Approve from "src/pages/high_risk/approve/index";
import PreWork15 from "src/pages/high_risk/prework15/index";
import PreWork5A from "src/pages/high_risk/prework5a/index";
// Ажилд гаргах зөвшөөрөл — анхан шатны удирдах ажилтны шийдвэр
import WorkApproval from "src/pages/high_risk/workApproval/index";
// АШУА-ийн ХАБЭА өдөр тутмын тайлан (14 асуумж) — асуумжийн лавлах нь
// /highrisk/reference → «Өдөр тутмын асуумж» табад.
import AshuaDaily from "src/pages/high_risk/ashuaDaily";
import PreworkBanner from "src/components/PreworkBanner";

/* ── LAZY: МЭРГЭЖИЛТНИЙ хуудсууд → "hse" chunk (2026-10-29) ───────────
   ⚠ ЯАГААД: доорх 4 хуудас 6 157 мөр эзэлдэг (лавлах сан 2 958, ТН-ээр
     бүртгэх 2 137) бөгөөд СТАТИК байсан тул `main.js` дотор орж, ээлж
     бүрийн 15А/5А асуумж нээхэд ч татагддаг байв.
   ⚠ Шинэ chunk БИШ — аль хэдийн байгаа "hse" бүлэгт нийлүүлэв, эвдрэх
     гадаргуу нэмэгдэхгүй. `lazyRetry` нь chunk олдохгүй бол дахин
     оролдоно; замын мод router.js-д Suspense + ChunkErrorBoundary дотор. */
const RegisterTn = lazyRetry(() =>
  import(/* webpackChunkName: "hse" */ "src/pages/high_risk/registerTn/index"),
);
// ӨЭА нарядын лавлах сан — HRT хуучин системээс шилжүүлсэн 8,581 мөр
const HrReference = lazyRetry(() =>
  import(/* webpackChunkName: "hse" */ "src/pages/high_risk/reference/index"),
);
// Зөвшөөрлийн хуудас хэвлэх — HRT-ийн usp_printHRT_* процедурын орлуулга
const PermitPrint = lazyRetry(() =>
  import(/* webpackChunkName: "hse" */ "src/pages/high_risk/print/index"),
);
// Тайлан — HRT-ийн CompletedHRTList / HRTlistbyDay-ийн орлуулга
const HighRiskReport = lazyRetry(() =>
  import(/* webpackChunkName: "hse" */ "src/pages/high_risk/report/index"),
);

// АШУА (мастер/хэсгийн дарга)-ийн banner-ыг /highrisk/* хуудаснуудын
// толгойд нэг удаа дуудаж тавина — хуудас бүрд тус тус дуудах хэрэггүй.
const HighRiskShell = ({ children }) => (
  <>
    <PreworkBanner mode="ashua" />
    {children}
  </>
);

const Main = () => {
  const data = [
    {
      path: "/highrisk/register",
      component: (
        <HighRiskContext>
          <HighRiskShell>
            <Register />
          </HighRiskShell>
        </HighRiskContext>
      ),
    },
    {
      path: "/highrisk/list",
      component: (
        <HighRiskContext>
          <HighRiskShell>
            <List />
          </HighRiskShell>
        </HighRiskContext>
      ),
    },
    {
      path: "/highrisk/approve",
      component: (
        <HighRiskContext>
          <HighRiskShell>
            <Approve />
          </HighRiskShell>
        </HighRiskContext>
      ),
    },
    // ӨЭА (Өндөр Эрсдэлт Ажилд) гарах ажилтны бүртгэл — АШУА удирдана
    {
      path: "/highrisk/registerTn",
      component: (
        <HighRiskShell>
          <RegisterTn />
        </HighRiskShell>
      ),
    },
    // ӨЭА ажилтны 15 чек листийн Pre-work шалгалт — асуудал илрүүлвэл
    // "Ажил зогсоох" хэлбэрээр аюулыг бүртгэнэ
    {
      path: "/highrisk/prework15",
      component: <PreWork15 />,
    },
    // Ажлын даалгаврын ажилтны 5А дадлын Pre-work шалгалт —
    // асуудал илрүүлвэл "Ажлын байрны үнэлгээ" хэлбэрээр аюулыг бүртгэнэ
    {
      path: "/highrisk/workapproval",
      component: (
        <HighRiskShell>
          <WorkApproval />
        </HighRiskShell>
      ),
    },
    {
      path: "/highrisk/prework5a",
      component: <PreWork5A />,
    },
    {
      // Лавлах сан — тоног төхөөрөмж, технологийн карт, ХАБЭА-н заавар.
      // PreworkBanner хэрэггүй (бүртгэлийн хуудас биш, лавлах).
      path: "/highrisk/reference",
      component: <HrReference />,
    },
    {
      // Хэвлэх харагдац — banner/цэсгүй, ЦЭВЭР маягт. `:id` нь нарядын id.
      path: "/highrisk/print/:id",
      component: <PermitPrint />,
    },
    {
      path: "/highrisk/report",
      component: <HighRiskReport />,
    },
    {
      // ⚠ ЦЭС нь энэ кодоор БИШ, SSO-гоос бүртгэгддэг.
      //   menu_link = "highrisk/ashuadaily"
      path: "/highrisk/ashuadaily",
      component: <AshuaDaily />,
    },
  ];
  return (
    <Routes>
      {_.map(data, (el) => {
        return (
          <Route key={el.path} exact path={el.path} element={el.component} />
        );
      })}
    </Routes>
  );
};

export default React.memo(Main);
